import { values } from '@weft/utils';
import { INVOICE_DUE_DATE_VALUES } from 'apps/app/src/pages/customers/CreateCustomerPage/create-customer-page-consts/invoice-due-date-consts';
import React from 'react';
import type { StyledTextField } from '../StyledTextField';
import { BaseSelect } from './BaseSelect';

type InvoiceDueDateSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.ComponentProps<typeof StyledTextField>['inputProps'];
};

export const InvoiceDueDateSelect = React.forwardRef<HTMLInputElement, InvoiceDueDateSelectProps>((props, ref) => {
  return (
    <BaseSelect
      {...props}
      ref={ref}
      values={values(INVOICE_DUE_DATE_VALUES)}
      label='Invoice Due Date'
      prefix="Net"
    />
  );
});